<template>
	<router-view v-if="isWeChart" />
	<div class="" v-else>请在微信端打开链接，使用微信浏览器访问</div>
</template>
<script setup>
import { watch } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
import { isWeChat } from './utils'
import { pushLog } from '@/api'
pushLog()
watch(
	() => route.meta?.title,
	(title) => {
		var merge = `厦门市摩托车交强险便民服务站${title ? `-${title}` : ''}`
		document.title = merge
	}
)
const isWeChart = isWeChat()
</script>
